import React from "react";

const Banner = () => {
  return (
    <div>
      <img
        style={{ width: "100%" }}
        src="https://premium.goauto.com.au/wp-content/uploads/2019/05/Isuzu_Ute_TVC_TH.jpg"
        alt=""
      />
    </div>
  );
};

export default Banner;
